import { CssBaseline } from '@mui/material';
import { Menu } from 'components';
import { AppThemeProvider, AuthProvider, MenuProvider, PopupProvider } from 'contexts';
import { Login } from 'pages';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from 'routes';

export const App = () => {
    return (
        <AuthProvider>
            <AppThemeProvider>
                <CssBaseline />
                <Login>
                    <PopupProvider>
                        <MenuProvider>
                            <BrowserRouter>
                                <Menu>
                                    <AppRoutes />
                                </Menu>
                            </BrowserRouter>
                        </MenuProvider>
                    </PopupProvider>
                </Login>
            </AppThemeProvider>
        </AuthProvider>
    );
};
